module.exports = __webpack_public_path__ + "static/media/import.2bc731c6.svg";